export default function CTASection() {
  return (
    <section className="relative w-full py-32 md:py-40 overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url(https://readdy.ai/api/search-image?query=Wide%20panoramic%20view%20of%20organized%20modern%20product%20fulfillment%20center%20with%20warm%20toned%20shelves%20of%20packed%20boxes%20and%20soft%20golden%20overhead%20lighting%20cream%20walls%20and%20polished%20concrete%20floor%20clean%20industrial%20aesthetic%20high%20key%20editorial%20photography%20spacious%20atmosphere&width=1600&height=800&seq=cta-warehouse-v2&orientation=landscape)`,
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-br from-foreground-900/50 via-foreground-900/30 to-foreground-900/20"></div>

      <div className="relative z-10 max-w-[1280px] mx-auto px-6 md:px-10 flex flex-col min-h-[400px]">
        <div className="mt-8 md:mt-16">
          <h2 className="font-heading text-5xl md:text-7xl font-bold text-background-50 leading-[1.05] max-w-[600px]">
            ready to scale<br />
            your store?
          </h2>
        </div>

        <div className="mt-auto mb-8 md:mb-16 flex flex-col sm:flex-row items-start sm:items-end justify-between gap-8">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-4 px-8 py-4 rounded-full bg-background-50 text-foreground-900 text-base font-semibold hover:bg-background-100 transition-all duration-300 whitespace-nowrap cursor-pointer group"
          >
            get itaobuy sheet
            <span className="w-10 h-10 rounded-full bg-foreground-900 flex items-center justify-center group-hover:scale-110 transition-transform">
              <i className="ri-arrow-right-line text-background-50 text-sm"></i>
            </span>
          </a>

          <p className="text-background-50/80 text-sm md:text-base leading-relaxed max-w-[340px]">
            Join thousands of resellers sourcing smarter.<br />
            New products added every Monday.
          </p>
        </div>
      </div>
    </section>
  );
}